/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsslSearchRequestBody } from '|api/commons';
import { PageIncidentLogAwareProcessDto } from '../../models/page-incident-log-aware-process-dto';

export interface IncidentLogSearch$Params {
  
    /**
     * Search API request body.
     */
    body?: EsslSearchRequestBody|null|undefined
}

export function incidentLogSearch(http: HttpClient, rootUrl: string, params?: IncidentLogSearch$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<PageIncidentLogAwareProcessDto>> {
  const rb = new RequestBuilder(rootUrl, incidentLogSearch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageIncidentLogAwareProcessDto>;
    })
  );
}

incidentLogSearch.PATH = '/incident-log/search-api';